<style scoped>
.emptyBox {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.emptyImg {
  width: 5.07rem;
  height: 4.1rem;
  background: url("~assets/artHealing.png") no-repeat center/cover;
  margin-top: 1.5rem;
  margin-bottom: 0.62rem;
  font-size: 0.3rem;
  color: #6f6f6f;
}
.itemBox {
  padding: 0.3rem;
  background: #fff;
  margin-bottom: 0.3rem;
  font-size: 0.3rem;
  color: #333;
  display: flex;
  justify-content: space-between;
  line-height: 0.42rem;
}
.itemRightBox {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  border-radius: 0.1rem;
  margin-left: 0.24rem;
}
</style>
<template>
  <div style="padding-top: 0.98rem">
    <topbar text="开心一刻"></topbar>
    <div class="emptyBox" v-if="emptyStatus && list.length == 0">
      <div class="emptyImg"></div>
      <div class="emptyName">目前还没有内容哦~</div>
    </div>
    <div class="jokeBox" v-else>
      <div
        class="itemBox"
        v-for="(item, index) in list"
        :key="index"
        @click="to(item.smileId)"
      >
        <div class="itemLeftBox">{{ item.smileTitle }}</div>
        <div
          class="itemRightBox"
          :style="{
            background: `url(${EnvUrl}${item.smilePic}) no-repeat center/cover`,
          }"
        ></div>
      </div>
      <no-more-data :noMoreData="noMoreData"></no-more-data>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import moment from "moment/moment";

import { Swiper, Slide } from "vue-swiper-component";
import { serialize } from "utils/index";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      pageIndex: 1,
      pageSize: 10,
      noMoreData: false,
      isLoading: false,
      emptyStatus: false,
      count: 0,
      list: [],
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    to(id) {
        this.$router.push(`/jokeDetail?id=${id}`)
    },
    handleScroll() {
      //                console.log(11)
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let bottomOfWindow =
        document.documentElement.offsetHeight -
          scrolltop -
          window.innerHeight <=
        200;
      if (bottomOfWindow && this.isLoading == false) {
        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
          this.noMoreData = true;
        } else {
          this.isLoading = true;
          this.pageIndex = this.pageIndex + 1;
          this.getList();
        }
      }
    },
    async getList() {
      let obj = {};
      obj.pageIndex = this.pageIndex;
      obj.pageSize = this.pageSize;
      // obj.userId = this.userId;
      obj.companyId = localStorage.getItem("companyId")
        ? localStorage.getItem("companyId")
        : "";
      let data = await getSources(
        "/bear-scale/api/microSmile/getSmileList",
        obj
      );
      if (data.status === 0) {
        this.isLoading = false;
        this.count = data.count;
        this.list = [...this.list, ...data.smileList];
        if (data.smileList.length == 0) {
          this.emptyStatus = true;
        } else {
          console.log(111111);
          if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
            console.log("显示");
            this.noMoreData = true;
          } else {
            console.log(2);
            this.noMoreData = false;
          }
        }
      } else {
        alert(data.msg);
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    this.userId = localStorage.getItem("userId");
    this.getList();
    window.addEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
};
</script>



// WEBPACK FOOTER //
// src/components/artHealing.vue?5d0a1aff